<template>
    <div>
        <div v-show="ready">
            <b-form>
                <people-form @ready="() => (peopleFormIsReady = true)" />
                <formation-form
                    :userId="userId"
                    :isCurrentUserOrAdminOrLocalAdmin="
                        isCurrentUserOrAdminOrLocalAdmin
                    "
                    @ready="() => (formationFormIsReady = true)"
                />
                <language-form
                    :userId="userId"
                    :isCurrentUserOrAdminOrLocalAdmin="
                        isCurrentUserOrAdminOrLocalAdmin
                    "
                    @ready="() => (languageIsReady = true)"
                />
                <career-in-the-company-form
                    :userId="userId"
                    :isCurrentUserOrAdminOrLocalAdmin="
                        isCurrentUserOrAdminOrLocalAdmin
                    "
                    @ready="() => (careerInCompanyIsReady = true)"
                />
                <career-in-the-market-form
                    :userId="userId"
                    :isCurrentUserOrAdminOrLocalAdmin="
                        isCurrentUserOrAdminOrLocalAdmin
                    "
                    @ready="() => (careerInMarketIsReady = true)"
                />
            </b-form>
        </div>
        <div v-if="!ready">
            <loader :loader="!ready" />
        </div>
    </div>
</template>

<script>
import Loader from '@/views/components/loader'
import PeopleForm from './forms/PeopleForm'
import FormationForm from './forms/FormationForm'
import LanguageForm from './forms/LanguageForm'
import CareerInTheCompanyForm from './forms/CareerInTheCompanyForm'
import CareerInTheMarketForm from './forms/CareerInTheMarketForm'
import { getParam } from '@/lib/url'

export default {
    name: 'MiniCurriculum',
    components: {
        Loader,
        PeopleForm,
        FormationForm,
        LanguageForm,
        CareerInTheCompanyForm,
        CareerInTheMarketForm,
    },
    data() {
        return {
            peopleFormIsReady: false,
            formationFormIsReady: false,
            languageIsReady: false,
            careerInCompanyIsReady: false,
            careerInMarketIsReady: false,
        }
    },
    computed: {
        ready() {
            return (
                this.peopleFormIsReady &&
                this.formationFormIsReady &&
                this.languageIsReady &&
                this.careerInCompanyIsReady &&
                this.careerInMarketIsReady
            )
        },
        currentUser() {
            return this.$store.state.currentUser.user
        },
        isCurrentUserOrAdminOrLocalAdmin() {
            return (
                this.currentUser.role.name == 'administrator' ||
                this.currentUser.id == getParam('id', this) ||
                this.currentUser.role.name == 'local_administrator'
            )
        },
        userId() {
            return getParam('id', this)
        },
    },
}
</script>
